import styled from 'styled-components'
import { ProductsSlider } from '@components/ProductsSlider/ProductsSlider'

export const StyledProductsSlider = styled(ProductsSlider)`
  width: 90vw;
  padding: 0;
  background: ${({ theme }) => theme.colors.background};
`

export const Container = styled.div`
  position: relative;
  width: 100%;
`
